<template>
  <div>
    <iframe
      :src="graficoUrl"
      style="width: 100%; height: 1100px"
      frameborder="0"
    ></iframe>
    <button
      v-if="shouldRenderButton"
      class="btn-voltar"
      @click="() => goBack(shouldReturnHome)"
      >
      Voltar
    </button>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getGraficosUrl } from '../services/graficoService'

const props = defineProps({
  id: {
    type: String,
    required: false,
  }
});

const route = useRoute()
const router = useRouter()
const graficoUrl = ref('')

function goBack(returnToHome) {
  if (returnToHome) {
    router.push({ path: '/' });
  } else {
    router.push({path: '/colecoes-nascimentos'});
  }
  window.scrollTo(0,0);
}

const shouldRenderButton = computed(()=> {
  return !route.params.forcedPath;
})

const shouldReturnHome = computed(() => {
  let shouldReturn;

  shouldReturn = router.currentRoute.value.path !== '/nascimentos' && router.currentRoute.value.path !== '/registros-tardios' && router.currentRoute.value.path !== '/orfaos';
  return shouldReturn;
})

onMounted(async () => {
  let res;
  switch (route.params.forcedPath) {
    case 'sap':
      res = await getGraficosUrl(532);
      break;
    default:
      res = await getGraficosUrl(props.id)
      break;
    }

  graficoUrl.value = res.iframeUrl;
})
</script>

<style lang="scss" scoped>
  .btn-voltar {
    width: 136px;
    height: 48px;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #155F6A;
    background: #FFFFFF;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #155F6A;
    transition: .25s;
    margin-left: 32px;
    margin-bottom: 32px;

    &:hover {
      background: #155F6A;
      color: #FFFFFF;
    }
  }
</style>